import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import qs from 'querystring'

import {
    getSystemAdminClients,
    doLogout,
} from '../../actions';

import SysadminClientListTable from '../../component/sysadmin/client/list_table';
import { Grid, Button, Form, Input,Dropdown } from 'semantic-ui-react';
import CommonUtility from "../../utils/CommonUtility";
import { USER_TYPE, USER_ROLES } from '../../constants';
import ExportUser from "./exportUser";


const filterOptions = [
    { key: 'name', text: 'Company Name', value: 'name' }, 
    { key: 'groupCode', text: 'Group Code', value: 'groupCode' },
    { key: 'policyNo', text: 'Policy No', value: 'policyNo' },
    
]

class SysadminClientPage extends Component {
    state = {
        currentPage: 1,
        perPage: 10,
        totalPage: 1,
        totalData: 1,
        isShowNextButton: true,
        isLoading: false,
        filter: 'name',
        isExportUser : false,
        query: '',
    }
    componentDidMount() { 
        if (this.props.user) {
            const { accessToken } = this.props.user;
            if (accessToken) {
                const query = qs.parse(this.props.location.search)
                let newState = {}
                if (query.page && query.v) {
                    newState = {
                        currentPage: parseInt(query.page),
                        perPage: parseInt(query.v)
                    }
                }
                if (query.filter && query.query) {
                    newState = {
                        ...newState,
                        query: query.query,
                        filter: query.filter
                    }
                }
                this.setState({ ...newState }, () => {
                    console.log("check get clients")
                    this.getClients();
                });
            }
        }
    }
    getClients = () => {
        const { accessToken } = this.props.user;

        let params = {}

        if (this.state.query !== '') {
            params[this.state.filter] = this.state.query

        }  
        this.setState({ isLoading: true }, () => {
            this.props.getSystemAdminClients({
                accessToken,
                searchPage: this.state.currentPage,
                searchMax: this.state.perPage,
                params
            }, (result, error) => {
                if(result && result.data && result.data.pagination){
                    this.setState({
                        totalPage: result.data.pagination.totalPage,
                        totalData: result.data.pagination.totalData,
                        isLoading: false,
                    })
                    let countNext = this.state.perPage * this.state.currentPage
                    if(countNext < result.data.pagination.totalData){
                        this.setState({
                            isShowNextButton : true
                        })
                    }else{
                        this.setState({
                            isShowNextButton : false
                        })
                    }
                } else if (error) {
                    console.log('getSystemAdminClients error', error);
                    if (error.errorCode === 401) {
                        console.log('Unauthorized or token expire.');
                        this.props.doLogout();
                        this.props.history.push('/');
                    }
                }
            });
        });
    }

    setParams = () => {
        let params = `page=${this.state.currentPage}&v=${this.state.perPage}`
        if (this.state.query !== '') { 
            params = params + `&filter=${this.state.filter}&query=${this.state.query}`
        }
        this.props.history.push({
            search: params
        })
    }
    
    goToPreviousPage = () => {
        if (this.state.currentPage > 1) {
            this.setState({ currentPage: this.state.currentPage - 1 }, () => {
                this.setParams();
                this.getClients();
            });
        };
    }

    goToNextPage = () => {
        if (this.props.clients.length >= this.state.perPage) {
            this.setState({ currentPage: this.state.currentPage + 1 }, () => {
                this.setParams();
                this.getClients();
            });
        };
    }

    setPage = (num) => {
        this.setState({ currentPage: num }, () => {
            this.setParams();
            this.getClients();
        });
    }

    setPerPage = (num) => {
        this.setState({ perPage: num, currentPage: 1 }, () => {
            this.setParams();
            this.getClients();
        });
    }

    submitFilter = () => {
        if (this.state.query !== '') {
            this.setState({...this.state, currentPage: 1}, () => {
                this.setParams();
                this.getClients();
            });
        }
    }

    exportUserClicked = () => {
            this.setState({
                isExportUser : true
            });
    }

    onCloseModal = () => {
            this.setState({
                isExportUser : false
            });
    }

    clearFilter = () => {
        this.setState({ query: '' }, () => {
            this.props.history.push({
                search: `page=${this.state.currentPage}&v=${this.state.perPage}`
            })
            this.getClients();
        });
    }

    checkClearFilter = (e) => {
        if(e.target.value == ""){
            this.setState({ query: '' }, () => {
            this.props.history.push({
                search: `page=${this.state.currentPage}&v=${this.state.perPage}`
            })
            this.getClients();
        });
        }
        this.setState({ query: e.target.value })
    }

    onFilterDropdownChange = (e, { value }) => { 
        this.setState({ filter: value });
    }
    render() {

        const isAdminOperation = CommonUtility.haveUserType( USER_TYPE.SYS_ADMIN, this.props.user ) && CommonUtility.haveRoles( [USER_ROLES.ADMIN_OPERATION], this.props.user );

        return (
            <>
                {this.state.isExportUser &&
                <ExportUser
                onCloseModal = {this.onCloseModal}
                />}
                <Grid columns="equal">
                    <Grid.Column>
                    { isAdminOperation &&  
                        <React.Fragment>
                            <Button as={Link} to="/systemadmin/client/create" color="blue" icon="add" content="Create client"/>
                            <Button as={Link} to="/systemadmin/user/upload" color="blue" icon="upload" content="Upload user"/>
                            <Button onClick={this.exportUserClicked} color="blue" icon="download" content="Export user"/>
                        </React.Fragment>
                    }
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <Form>
                            <Input fluid type='text' placeholder='Search...' action>
                                <input value={this.state.query} onChange={(e) => this.checkClearFilter(e)} />
                                <Dropdown placeholder='Filter by' selection options={filterOptions}
                                    value={this.state.filter} onChange={this.onFilterDropdownChange}/>
                                <Button type="submit" color="green" icon="search" content="Search" onClick={this.submitFilter}/>
                                { this.state.query.length > 0 &&
                                    <Button type="button" color="black" icon="close" content="Clear" onClick={this.clearFilter}/>
                                }
                            </Input>
                        </Form>
                    </Grid.Column>
                </Grid>
                <SysadminClientListTable
                    clients={this.props.clients}
                    isLoading={this.state.isLoading}
                    isShowNextButton = {this.state.isShowNextButton}
                    users={this.props.users}
                    currentPage={this.state.currentPage}
                    perPage={this.state.perPage}
                    totalPage={this.state.totalPage}
                    totalData={this.state.totalData}
                    setPage={(num) => this.setPage(num)}
                    setPerPage={(num) => this.setPerPage(num)}
                    goToPreviousPage={() => this.goToPreviousPage()}
                    goToNextPage={() => this.goToNextPage()}
                    paginationHandler={this.paginationHandler}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.user,
        clients: state.systemAdmin.clients,
    };
}

export default withRouter(connect(mapStateToProps, { getSystemAdminClients,doLogout,})(SysadminClientPage));